// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router';
import BootstrapVue from 'bootstrap-vue'
import store from './store';
import './function'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret,faExchangeAlt,faPlusCircle,faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueElementLoading from 'vue-element-loading'
import Notifications from 'vue-notification'
import VeeValidate from 'vee-validate';

library.add(faUserSecret,faExchangeAlt,faPlusCircle,faStar)

Vue.component('VueElementLoading', VueElementLoading)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VeeValidate);
Vue.use(Notifications)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
Vue.filter('snippetMore', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 85) {
      return value;
    }
    return `${value.slice(0, 85)}...`;
  }
});

Vue.filter('snippet', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 75) {
      return value;
    }
    return `${value.slice(0, 75)}...`;
  }
});
Vue.filter('snippetmoreMid', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 70) {
      return value;
    }
    return `${value.slice(0, 70)}...`;
  }
});

Vue.filter('snippetMid', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 65) {
      return value;
    }
    return `${value.slice(0, 65)}...`;
  }
});
Vue.filter('snippetmoreSmall', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 60) {
      return value;
    }
    return `${value.slice(0,60)}...`;
  }
});
Vue.filter('snippetSmall', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 50) {
      return value;
    }
    return `${value.slice(0, 50)}...`;
  }
});


Vue.filter('snippetSmallDoc', (value) => {
  const char = value.length;
  if (char <= 45) {
    return value;
  }
  return `${value.slice(0, 45)}...`;
});
Vue.filter('snippetLessSmallDoc', (value) => {
  const char = value.length;
  if (char <= 40) {
    return value;
  }
  return `${value.slice(0, 40)}...`;
});


Vue.filter('snippetProfileEdit', (value) => {
  if (typeof value !=='undefined') {
    const char = value.length;
    if (char <= 30) {
      return value;
    }
    return `${value.slice(0, 30)}...`;
  }

  return ''
});
Vue.filter('snippetProfileEdit2', (value) => {
  if (typeof value !=='undefined') {
    const char = value.length;
    if (char <= 22) {
      return value;
    }
    return `${value.slice(0, 22)}...`;
  }

  return ''
});
Vue.filter('snippetMiniSmall', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 18) {
      return value;
    }
    return `${value.slice(0, 18)}...`;
  }
});

Vue.filter('snippetMobile', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 15) {
      return value;
    }
    return `${value.slice(0, 15)}...`;
  }
});

Vue.filter('snippetMobileSmall', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 8) {
      return value;
    }
    return `${value.slice(0, 8)}...`;
  }
});

Vue.filter('snippetMilestone', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 28) {
      return value;
    }
    return `${value.slice(0, 28)}...`;
  }
});


// WEBPACK FOOTER //
// ./src/main.js